import { render, staticRenderFns } from "./ConfirmUserAccountPage.vue?vue&type=template&id=522053d9"
import script from "./ConfirmUserAccountPage.vue?vue&type=script&lang=js"
export * from "./ConfirmUserAccountPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports